import React from "react";
import PropTypes from "prop-types";

import StandardTAC from "./StandardTAC";
import ComponentMissing from "../../Debug/ComponentMissing";

const TeaserAndChartSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  charts,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    charts,
    animation,
  };

  function switchTeaserAndChart() {
    switch (layout) {
      case "standard":
        return <StandardTAC properties={properties} />;
      default:
        return <ComponentMissing type="TeaserAndChart" subType={layout} />;
    }
  }

  return switchTeaserAndChart();
};

TeaserAndChartSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  mirrored: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  animation: PropTypes.instanceOf(Object),
};

export default TeaserAndChartSwitcher;
